/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV6OnSiteAlertLicenseNotificationParams,
  GetV6OnSiteAlertNotificationParams,
  LicenseOnSiteAlertResponse,
  OnSiteAlertResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 라이센스 On Site 알람
 */
export const getV6OnSiteAlertLicenseNotification = (
  params?: MaybeRef<GetV6OnSiteAlertLicenseNotificationParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<LicenseOnSiteAlertResponse>(
    {
      url: `/api/v6/onSite/alert/license-notification`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV6OnSiteAlertLicenseNotificationQueryKey = (
  params?: MaybeRef<GetV6OnSiteAlertLicenseNotificationParams>,
) => {
  return [
    'api',
    'v6',
    'onSite',
    'alert',
    'license-notification',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV6OnSiteAlertLicenseNotificationQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV6OnSiteAlertLicenseNotificationParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6OnSiteAlertLicenseNotificationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>> = ({
    signal,
  }) => getV6OnSiteAlertLicenseNotification(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>,
    TError,
    TData
  >;
};

export type GetV6OnSiteAlertLicenseNotificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>
>;
export type GetV6OnSiteAlertLicenseNotificationQueryError = ErrorType<unknown>;

/**
 * @summary 라이센스 On Site 알람
 */

export function useGetV6OnSiteAlertLicenseNotification<
  TData = Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV6OnSiteAlertLicenseNotificationParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV6OnSiteAlertLicenseNotification>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6OnSiteAlertLicenseNotificationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary On Site 알람
 */
export const getV6OnSiteAlertNotification = (
  params?: MaybeRef<GetV6OnSiteAlertNotificationParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<OnSiteAlertResponse>(
    { url: `/api/v6/onSite/alert/notification`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV6OnSiteAlertNotificationQueryKey = (
  params?: MaybeRef<GetV6OnSiteAlertNotificationParams>,
) => {
  return ['api', 'v6', 'onSite', 'alert', 'notification', ...(params ? [params] : [])] as const;
};

export const getGetV6OnSiteAlertNotificationQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV6OnSiteAlertNotificationParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6OnSiteAlertNotificationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>> = ({
    signal,
  }) => getV6OnSiteAlertNotification(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>,
    TError,
    TData
  >;
};

export type GetV6OnSiteAlertNotificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>
>;
export type GetV6OnSiteAlertNotificationQueryError = ErrorType<unknown>;

/**
 * @summary On Site 알람
 */

export function useGetV6OnSiteAlertNotification<
  TData = Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV6OnSiteAlertNotificationParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV6OnSiteAlertNotification>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6OnSiteAlertNotificationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
